import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const Breadcrumbs = ({ items }) => {
  // items: [{label, to}], last item is current page (no link)
  return (
    <nav aria-label="Breadcrumb" className="text-xs" data-testid="breadcrumbs">
      <ol className="flex items-center gap-1.5 flex-wrap text-muted-foreground">
        <li>
          <Link to="/" className="hover:text-primary inline-flex items-center gap-1">
            <Home className="h-3 w-3" /> Home
          </Link>
        </li>
        {items.map((it, i) => (
          <React.Fragment key={i}>
            <li aria-hidden="true"><ChevronRight className="h-3 w-3" /></li>
            <li>
              {it.to ? (
                <Link to={it.to} className="hover:text-primary">{it.label}</Link>
              ) : (
                <span className="text-foreground font-medium">{it.label}</span>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
